
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="LogoKfzteileComSvg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 241 24"><path fill="#fff" d="M9.3 16l-1.6 1.8V23h-7V2h7v7.6L14.6 2h7.7l-8.4 9.2L22.7 23h-8.2l-5.2-7zm21.4-8.7v3.6h8.8v5.3h-8.8v6.7h-7.1v-21h17.1v5.3h-10zm30.8 10.2V23H42.2v-4.3l9.6-11.2h-9.3V2H61v4.3l-9.6 11.2h10.1zm6.6-10H62V2h19.4v5.5h-6.1V23h-7.1V7.5zm32.6 10.2V23H83.2V2h17.1v5.3H90.2v2.5H99v5.1h-8.8v2.8h10.5zM103.4 2h7.1v21h-7.1V2zm10.5 0h7.1v15.5h9.5V23h-16.6V2zm36 15.7V23h-17.5V2h17.1v5.3h-10.1v2.5h8.9v5.1h-8.9v2.8h10.5z"/><path fill="#e0e0e0" d="M157.5 22.1a9.9 9.9 0 01-4.2-3.9c-1-1.7-1.5-3.6-1.5-5.7s.5-4 1.5-5.7 2.4-3 4.2-3.9a13.84 13.84 0 0111.5-.3c1.6.7 2.9 1.8 4 3.1l-4.5 4c-1.3-1.6-2.8-2.5-4.6-2.5-1.5 0-2.7.5-3.6 1.4-.9 1-1.4 2.2-1.4 3.8 0 1.6.5 2.9 1.4 3.8.9 1 2.1 1.4 3.6 1.4 1.8 0 3.3-.8 4.6-2.5l4.5 4c-1 1.4-2.4 2.4-4 3.1-1.6.7-3.4 1.1-5.5 1.1-2.3.2-4.3-.3-6-1.2zm21.9 0a9.9 9.9 0 01-4.2-3.9c-1-1.7-1.5-3.6-1.5-5.7s.5-4 1.5-5.7c1-1.7 2.4-3 4.2-3.9 1.8-.9 3.8-1.4 6.1-1.4s4.3.5 6.1 1.4c1.8.9 3.2 2.2 4.2 3.9 1 1.7 1.5 3.6 1.5 5.7s-.5 4-1.5 5.7c-1 1.7-2.4 3-4.2 3.9-1.8.9-3.8 1.4-6.1 1.4s-4.3-.5-6.1-1.4zm8.5-5c.7-.4 1.3-1 1.7-1.8s.6-1.7.6-2.8c0-1.1-.2-2-.6-2.8-.4-.8-1-1.4-1.7-1.8-.7-.4-1.5-.6-2.4-.6s-1.7.2-2.4.6c-.7.4-1.3 1-1.7 1.8-.4.8-.6 1.7-.6 2.8 0 1.1.2 2 .6 2.8s1 1.4 1.7 1.8c.7.4 1.5.6 2.4.6s1.7-.2 2.4-.6zm30.8 5.9l-.1-9.6-4.6 7.7h-3.1l-4.6-7.4v9.2h-6.5v-21h5.8l6.8 11.2 6.7-11.2h5.8l.1 21h-6.3z"/><path fill="#fff" d="M238.2 1.5c.9.5 1.5 1.2 2 2 .5.9.7 1.8.7 2.9 0 1-.2 2-.8 2.9s-1.2 1.6-2 2.1a5.74 5.74 0 01-5.8 0c-.9-.5-1.5-1.2-2-2-.5-.9-.7-1.8-.7-2.8a5.3 5.3 0 012.7-4.8c.9-.5 1.8-.8 2.9-.8s2.1 0 3 .5zm-.6 8.9c.7-.4 1.2-1 1.6-1.7a4.65 4.65 0 000-4.6c-.4-.7-.9-1.2-1.6-1.6a4.65 4.65 0 00-4.6 0c-.7.4-1.2 1-1.6 1.7a4.65 4.65 0 000 4.6c.4.7.9 1.3 1.6 1.7.7.4 1.5.6 2.3.6s1.6-.3 2.3-.7zm.3-3.7c-.2.3-.5.6-.9.8l1.4 2.1h-1.7l-1.2-1.8h-1.1v1.8h-1.7V3.4h2.7c.8 0 1.5.2 2 .6.5.4.7.9.7 1.6.1.4 0 .7-.2 1.1zm-2.5-.2c.4 0 .7-.1.9-.2.2-.2.3-.4.3-.7s-.1-.5-.3-.7-.5-.3-.9-.3h-.9v1.9h.9z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'LogoKfzteileComSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
